// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2XGYh","header":"ReportDetails_header__9z7EP","title":"ReportDetails_title__2ZuLm","left":"ReportDetails_left__2hTQf"};